import React, { Component } from 'react'
import Background from './getBlogs'

class Blogger extends Component {

  componentDidMount = () => {
    window.analytics.page()
  }

  render(){

    return (
    <div className="bodydiv">
    <div className="titlediv">Blogger JSON API Example</div>
    <div id="content">
    </div>
    <Background />
    </div>
    )
  }
}

export default Blogger;







// WEBPACK FOOTER //
// ./src/components/Blogger.js